module.exports = __webpack_public_path__ + "media/images/LearnMore11-2f5d7e070138a085a6a579b70f01587b.png";